import Model from "../../model"
import { ID } from "../../types"

import Command, { CommandName } from "../command"

export type ViewIdeaCommandState = {
  id: ID
  viewedAt: Date
}

export default class ViewIdeaCommand extends Command {
  name: CommandName = "view-idea"
  state: ViewIdeaCommandState
  undoable = false

  constructor(state: ViewIdeaCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - idea might have been deleted or unplaced (Cancel)
  resolveConflicts(model: Model): ViewIdeaCommandState | null {
    const idea = model.getIdea(this.state.id)
    if (!idea || idea.type === "fleeting") return null
    return this.state
  }

  local(model: Model): any {
    model.setIdeaLastViewedAt(this.state.id, this.state.viewedAt)
  }

  undo(): Command[] {
    return []
  }
}
